module.exports = __webpack_public_path__ + "ac4e9cf72ccef772b05025d32e0daef2.pdf";